module.exports = "https://bicocca-network.servercdn.it/static/img/upload.svg?a5aa61d490eb6c08d768bfe52fc48a75";